export default __webpack_public_path__ + "static/suitcase-09044cf2a3274e4f7737b268121985d8.png";